//main-cart-items.liquid (gift coupon redemption)
var domain;
var shopifyDomain = "https://" + window.location.hostname + "/";

if(window.location.hostname.toLowerCase() == "dev-jp-rituals.myshopify.com") {
  //TEST
  domain = "https://crm-test-jp.bluebellgroup.com/RTJPCONTEST/v1/api";
} else {
  //PROD
  domain = "https://crm-jp-rituals.bluebellgroup.com/v1/api";
}

function getActivePurchaseEvent(apikey, successCallback, errorCallback) {
  let headers = { "Content-Type": "application/json" };
  if (apikey && apikey.length > 0) {
    headers["bb-Shopify-API-Key"] = apikey;
  } else {
    headers["bb-Shopify-Domain"] = shopifyDomain;
  }

  $.ajax({
    url: domain + "/Shopify/ActivePurchaseEvent",
    type: "GET",
    headers: headers,
    success: function (data) {
      successCallback(data);
    },
    error: function (req, status, err) {
      errorCallback(req, status, err);
    },
  });
}

function tryToRedeemCoupon(
  apikey,
  couponNumber,
  couponSubtitle,
  discType,
  callback
) {
  LoadingSpinner();

  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      console.log(json);
      if (json["item_count"] > 0) {
        const cartTotal = json["total_price"];
        const itemsArr = json["items"];
        let discountApplied = false;
        for (var i = 0; i < itemsArr.length; i++) {
          const item = itemsArr[i];
          const properties = item["properties"];
          const discounts = item["discounts"];
          if (discounts.length <= 0) {
            if (item["properties"]["_bon_couponNumber"] !== undefined) {
              discountApplied = true;
              break;
            }
          } else {
            discountApplied = true;
            break;
          }
        }
        if (discountApplied == false) {
          console.log("No discount is applied to the product at this moment.");
          checkCoupon(
            apikey,
            couponNumber,
            cartTotal,
            couponSubtitle,
            discType,
            callback
          );
        } else {
          const background = document.getElementById(
            "couponErrorPromptBackground"
          );
          const message = document.getElementById("couponErrorMessage");
          background.style.display = "flex";
          message.innerHTML =
            "クーポンが既にカートへ適用されています。他のクーポンとの併用はできません。";
          DoNotReloadPromptBtn();
          RemoveLoadingSpinner();
        }
      } else {
        const background = document.getElementById(
          "couponErrorPromptBackground"
        );
        const message = document.getElementById("couponErrorMessage");
        background.style.display = "flex";
        message.innerHTML =
          "このクーポンを使用するためには、商品をカートへ追加してから使用ボタンを押してください。";
        DoNotReloadPromptBtn();
        RemoveLoadingSpinner();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      const message = document.getElementById("couponErrorMessage");
      background.style.display = "flex";
      message.innerHTML =
        "<div class='veryLongErrorMessage'>クーポン適用ができませんでした。<br>しばらく時間をおいてから再度アクセスしてください。<br>それでも問題が解決しない場合は、お手数ですが<a href='/pages/contact'>お問い合わせフォーム</a>からご連絡ください。</div>";
      DoNotReloadPromptBtn();
      RemoveLoadingSpinner();
    });
}

function checkCoupon(
  apikey,
  couponNumber,
  cartTotal,
  couponSubtitle,
  discType,
  callback
) {
  $.ajax({
    url: domain + "/Shopify/ECoupon?couponNumber=" + couponNumber,
    type: "GET",
    headers: {
      "bb-Shopify-API-Key": apikey,
    },
    success: function (data) {
      let x = JSON.stringify(data);
      console.log(x);

      const currentCouponNumber = data["couponNumber"];
      const minimumPurchaseAmount = data["minPurchaseAmount"];
      console.log("The total price is " + cartTotal);

      if (cartTotal / 100 >= minimumPurchaseAmount) {
        if ("items" in data) {
          console.log("This is a product redeem coupon.");

          const jsonItemArray = data["items"];

          let itemsToAdd = [];

          const length = jsonItemArray.length;
          for (let i = 0; i < length; i++) {
            const currentItem = jsonItemArray[i];
            const formDataObject = {
              id: currentItem.shopifyVariant_ID,
              quantity: currentItem.qty,
              properties: {
                _bon_couponNumber: currentCouponNumber,
                _couponSubtitle: couponSubtitle,
              },
            };
            itemsToAdd.push(formDataObject);
          }

          console.log(itemsToAdd);
          addProduct(itemsToAdd, discType, callback);
        } else {
          console.log("This is a price discount coupon.");
          const discountAmount = data["discAmount"];
          addPriceDiscountCoupon(couponNumber, discType, callback);
        }
      } else {
        const background = document.getElementById(
          "couponErrorPromptBackground"
        );
        const message = document.getElementById("couponErrorMessage");
        background.style.display = "flex";
        message.innerHTML =
          "このクーポンを適用するためのカート合計金額条件を満たしていません。クーポン一覧より条件をご確認の上、今一度お試しください。";
        DoNotReloadPromptBtn();
        RemoveLoadingSpinner();
      }
    },
    error: function (request, status, error) {
      const background = document.getElementById("couponErrorPromptBackground");
      const message = document.getElementById("couponErrorMessage");

      const bbError = request.responseJSON["bb_error"];
      if (bbError) {
        console.log(request);
        console.log(status);
        console.log(error);
        switch (bbError) {
          case "Invalid coupon status: 2":
            background.style.display = "flex";
            message.innerHTML = "このクーポンは無効です。";
            DoNotReloadPromptBtn();
            break;
          case "Invalid coupon status: 4":
            background.style.display = "flex";
            message.innerHTML = "このクーポンの使用上限に達しました。";
            DoNotReloadPromptBtn();
            break;
          case "Invalid coupon status: 8":
            background.style.display = "flex";
            message.innerHTML = "このクーポンはまだご利用いただけません。";
            DoNotReloadPromptBtn();
            break;
          case "Invalid coupon status: 16":
            background.style.display = "flex";
            message.innerHTML = "このクーポンは使用期限切れです。";
            DoNotReloadPromptBtn();
            break;
          case "Coupon number is invalid":
            background.style.display = "flex";
            message.innerHTML = "このクーポンは無効です。";
            DoNotReloadPromptBtn();
            break;
        }
        RemoveLoadingSpinner();
      }
    },
  });
}

function addProduct(items, discType, callback) {
  let formData = {
    items: items,
  };

  let success = false;
  const background = document.getElementById("couponErrorPromptBackground");
  const message = document.getElementById("couponErrorMessage");

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      success = response.ok;
      return response.json();
    })
    .then((body) => {
      console.log(body);
      if (success) {
        if (callback !== undefined) {
          callback(discType);
        }
      } else {
        background.style.display = "flex";
        message.innerHTML = "このクーポンは無効です。";
        DoNotReloadPromptBtn();
        RemoveLoadingSpinner();
      }
    })
    .catch((error) => {
      background.style.display = "flex";
      message.innerHTML = "このクーポンは無効です。";
      DoNotReloadPromptBtn();
      console.error("Error:", error);
      RemoveLoadingSpinner();
    });
}

function addPriceDiscountCoupon(couponNumber, discType, callback) {
  console.log(discType);
  $.ajax({
    url: shopifyDomain + "discount/" + couponNumber,
    type: "GET",
    success: function (data) {
      if (callback !== undefined) {
        callback(discType);
      }
    },
    error: function (error) {
      console.log(error);
    },
  });
}

function reloadAfterAddingCoupons() {
  var url = window.location.href;
  var parsedUrl = new URL(url);
  var searchParams = parsedUrl.searchParams;
  searchParams.delete("couponNumber");
  parsedUrl.search = searchParams.toString();
  var updatedUrl = parsedUrl.toString();
  console.log(updatedUrl);
  window.history.pushState({}, "", updatedUrl);
  window.location.reload();
}

function displaySuccessMessage(discType) {
  const background = document.getElementById("couponErrorPromptBackground");
  const message = document.getElementById("couponErrorMessage");
  background.style.display = "flex";
  if (discType == 10) {
    message.innerHTML =
      "クーポンを適用しました。<br> 送料無料はご購入手続きのページにて適用されます。";
    AddReloadToPromptBtn();
  } else {
    message.innerHTML = "クーポンを適用しました。";
    AddReloadToPromptBtn();
  }
  RemoveLoadingSpinner();
}

// end of coupon redemption

// My-Coupons Page

function GetCouponInfo(apikey, validity) {
  removeCouponDiv();
  $.ajax({
    url: domain + "/Shopify/CustomerECoupons?" + validity + "=true",
    type: "GET",
    headers: {
      "bb-Shopify-API-Key": apikey,
    },
    success: function (data) {
      console.log(data);
      console.log(data.length);
      const couponContainer = document.getElementById("coupon-container-id");

      const length = data.length;
      if (length == 0) {
        const couponDiv = document.createElement("div");
        couponDiv.innerHTML = `
            <div style="text-align:center; font-family:'Noto Serif JP';">クーポンがありません。</div>
        `;
        couponDiv.classList.add("coupon-empty");
        const couponContainerDiv = document.getElementById(
          "coupon-container-id"
        );
        couponContainerDiv.appendChild(couponDiv);
      }

      for (let i = 0; i < length; i++) {
        const currentItem = data[i];
        const couponNumber = currentItem["couponNumber"];
        const couponTitle = currentItem["title"];
        const couponSubtitle = currentItem["subtitle"];
        const couponExpiryDate = currentItem["expiryDate"];
        const couponNote = currentItem["note"];
        const couponImageURL = currentItem["imageUrl"];
        const discType = currentItem["discType"];
        const remainingUsedTime = currentItem["remainingUsedTime"];
        const isVoided = currentItem["isVoided"];

        const today = new Date();
        const dateCouponExpiryDate = new Date(couponExpiryDate);

        let expiredButtonText;
        if (remainingUsedTime == 0) {
          expiredButtonText = "使用済み";
        } else if (isVoided) {
          expiredButtonText = "無効";
        } else if (dateCouponExpiryDate.getTime() <= today.getTime()) {
          expiredButtonText = "使用期限切れ";
        } else {
          expiredButtonText = "使用期限切れ";
        }

        const btnid = i;
        createCouponDiv(
          couponTitle,
          couponSubtitle,
          couponExpiryDate,
          couponNote,
          couponImageURL,
          couponNumber,
          apikey,
          validity,
          discType,
          expiredButtonText,
          btnid
        );

        if (validity == "Available") {
          addEventListenertoRedeemButtons(apikey, btnid);
        }
      }
    },
    error: function (error) {
      console.log(error);
      const background = document.getElementById("couponErrorPromptBackground");
      const message = document.getElementById("couponErrorMessage");
      background.style.display = "flex";
      message.innerHTML =
        "<div class='veryLongErrorMessage'>クーポン適用ができませんでした。<br>しばらく時間をおいてから再度アクセスしてください。<br>それでも問題が解決しない場合は、お手数ですが<a href='/pages/contact'>お問い合わせフォーム</a>からご連絡ください。</div>";
      DoNotReloadPromptBtn();
    },
  });
}

// Add Event Listener to Redeem Button
function addEventListenertoRedeemButtons(apikey, btnid) {
  const btnName = "coupon-info-button" + btnid;
  const btn = document.getElementById(btnName);
  btn.addEventListener("click", () => {
    const couponNumber = btn.dataset.couponnumber;
    const couponSubtitle = btn.dataset.couponsubtitle;
    const discType = btn.dataset.disctype;
    tryToRedeemCoupon(apikey, couponNumber, couponSubtitle, discType, () => {
      displaySuccessMessage(discType);
    });
  });
}

// Create Coupons
function createCouponDiv(
  couponTitle,
  couponSubtitle,
  couponExpiryDate,
  couponNote,
  couponImageUrl,
  couponNumber,
  apikey,
  validity,
  discType,
  expiredButtonText,
  btnid
) {
  const formattedDate = formatDate(couponExpiryDate);
  const couponDiv = document.createElement("div");
  if (validity == "Available") {
    couponDiv.classList.add("coupon");
    couponDiv.innerHTML = `
      <img class="coupon-ribbon-image" draggable="false" src="https://cdn.shopify.com/s/files/1/0674/3913/2918/files/my-coupon-ribbon.png?v=1716365822">
      <div class="coupon-info-wrap">
        <div class="coupon-image-wrap">
          <img draggable="false" src="${couponImageUrl}">
        </div>
        <div class="coupon-info">
          <div class="coupon-info-lineOne">${couponSubtitle}</div>
          <div class="coupon-info-lineTwo">${couponTitle}</div>
          <div class="coupon-info-lineThree">
            <div>使用期限: </div>
            <div class="coupon-info-expiry-date">${formattedDate}</div>
          </div>
          <div class="coupon-info-lineFour">
            ${couponNote}
          </div>
          <div data-couponNumber="${couponNumber}" data-couponSubtitle="${couponSubtitle}" data-discType="${discType}" data-btnid="${btnid}" class="coupon-info-button" id="coupon-info-button${btnid}">使用する</div>
        </div>
      </div>
    `;
  } else {
    couponDiv.classList.add("coupon-Expired");
    couponDiv.innerHTML = `
      <img class="coupon-ribbon-image" draggable="false" src="https://cdn.shopify.com/s/files/1/0674/3913/2918/files/my-coupon-ribbon.png?v=1716365822">
      <div class="coupon-info-wrap">
        <div class="coupon-image-wrap">
          <img draggable="false" src="${couponImageUrl}">
        </div>
        <div class="coupon-info">
        <div class="coupon-info-lineOne">${couponSubtitle}</div>
          <div class="coupon-info-lineTwo">${couponTitle}</div>
          <div class="coupon-info-lineThree">
            <div>Expiry Date: </div>
            <div class="coupon-info-expiry-date">${formattedDate}</div>
          </div>
          <div class="coupon-info-lineFour">
            ${couponNote}
          </div>
          <div class="coupon-info-button-Expired">${expiredButtonText}</div>
        </div>
      </div>
    `;
  }

  const couponContainerDiv = document.getElementById("coupon-container-id");
  couponContainerDiv.appendChild(couponDiv);
}

// Remove existing coupons before button click
function removeCouponDiv() {
  const couponContainer = document.getElementById("coupon-container-id");
  if (couponContainer) {
    const coupondivs = document.getElementsByClassName("coupon");
    while (coupondivs.length > 0) {
      coupondivs[0].remove();
    }

    const coupondivsExpired = document.getElementsByClassName("coupon-Expired");
    while (coupondivsExpired.length > 0) {
      coupondivsExpired[0].remove();
    }

    const coupondivsEmpty = document.getElementsByClassName("coupon-empty");
    while (coupondivsEmpty.length > 0) {
      coupondivsEmpty[0].remove();
    }
  }
}

function formatDate(couponExpiryDateString) {
  const couponExpiryDate = new Date(couponExpiryDateString);
  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const month = months[couponExpiryDate.getMonth()];
  const day = couponExpiryDate.getDate().toString().padStart(2, "0");
  const year = couponExpiryDate.getFullYear();
  return `${year}-${month}-${day}`;
}

// End of My-Coupons Page

// Order related
function getCustomerOrderHeaders(offset, limit, apiKey, successCallback) {
  $.ajax({
    url: `${domain}/Shopify/Orders?offset=${offset}&limit=${limit}`,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("bb-Shopify-API-Key", apiKey);
    },
    success: successCallback,
    error: function (error) {
      console.log(error);
    },
  });
}

function getCustomerOrderDetail(
  transactionNumberType,
  transactionNumber,
  apiKey,
  successCallback
) {
  $.ajax({
    url: `${domain}/Shopify/Order?transactionNumberType=${transactionNumberType}&transactionNumber=${transactionNumber}`,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("bb-Shopify-API-Key", apiKey);
    },
    success: successCallback,
    error: function (error) {
      console.log(error);
    },
  });
}

// End of Order related

function getCustomerCode(apiKey, successCallback) {
  if (!successCallback) {
    successCallback = function (data) {};
  }
  $.ajax({
    url: domain + "/Shopify/CustomerCode",
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("bb-Shopify-API-Key", apiKey);
    },
    success: successCallback,
    error: function (error) {
      console.log(error);
    },
  });
}

// Loading Spinner
function LoadingSpinner() {
  const LoadingSpinnerDiv = document.createElement("div");
  LoadingSpinnerDiv.id = "BBHKITLoadingSpinnerOverlay";
  LoadingSpinnerDiv.innerHTML = `<div class="BBHKITLoadingSpinnerOverlayFixed"><span class="BBHKITLoadingSpinner"></span></div>`;

  const mainbody = document.getElementById("MainContent");
  mainbody.appendChild(LoadingSpinnerDiv);
  console.log("End start loading spinner");
}

// Remove Loading Spinner
function RemoveLoadingSpinner() {
  const loadingSpinner = document.getElementById("BBHKITLoadingSpinnerOverlay");
  loadingSpinner.remove();
}

//Clear Cart
function EmptyCartAfterLogout() {
  console.log("logout");

  fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.ok) {
        // Redirect to logout page
        window.location.href = "/account/logout";
      } else {
        return response.json().then((error) => {
          console.error("Error:", error);
        });
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

//Check Free Shipping Coupon (Cart Drawer)
function DisplayHideFSMessage(apikey) {
  const freeShippingMsg = document.getElementsByClassName(
    "bbhkit-freeShippingMsg"
  );

  GetCouponInfoForCartDrawer(apikey, "Available", (hasFSCoupon) => {
    if (freeShippingMsg.length > 0) {
      for (let i = 0; i < freeShippingMsg.length; i++) {
        if (hasFSCoupon) {
          freeShippingMsg[i].style.display = "block";
        } else {
          freeShippingMsg[i].style.display = "none";
        }
      }
    }
  });
}

function GetCouponInfoForCartDrawer(apikey, validity, callback) {
  let hasFSCoupon = false;

  $.ajax({
    url: domain + "/Shopify/CustomerECoupons?" + validity + "=true",
    type: "GET",
    headers: {
      "bb-Shopify-API-Key": apikey,
    },
    success: function (data) {
      const length = data.length;

      for (let i = 0; i < length; i++) {
        const currentItem = data[i];
        const discType = currentItem["discType"];
        if (discType == 10) {
          hasFSCoupon = true;
          break;
        }
      }
    },
    error: function (error) {
      console.log(error);
    },
    complete: function () {
      callback(hasFSCoupon);
    },
  });
}

//Add reload function to close coupon prompt message button
function AddReloadToPromptBtn() {
  const closebutton = document.getElementById("CouponErrorCloseButton");
  closebutton.addEventListener("click", ReloadcloseCouponError);
}

function DoNotReloadPromptBtn() {
  const closebutton = document.getElementById("CouponErrorCloseButton");
  closebutton.addEventListener("click", JustcloseCouponError);
}

function ReloadcloseCouponError() {
  background.style.display = "none";
  window.location.reload();
}

function JustcloseCouponError() {
  background.style.display = "none";
}
